<template>
  <view-section
    :title="$t('table_of_contents')"
    :padding-y="false"
    :panel-loading="loading"
    :expandable="expandable"
  >
    <loading-content v-if="!guide" hide-title class="tw-my-2.5" />
    <ul v-else class="tw-pl-2 tw-py-1">
      <li v-if="!navHeaders.length" class="tw-py-0.5">
        <a
          :href="`#${HEADER_ID}`"
          class="tw-font-medium"
          :class="linkClass"
          @click.prevent="goToId('guide')"
        >
          {{ $t('guide') }}
        </a>
      </li>
      <li v-for="item in navHeaders" :key="item.name" class="tw-py-0.5">
        <a
          :href="`#${generateChildHeadingId(item.id)}`"
          class="tw-font-medium mod-util-truncate-one-line"
          :class="linkClass"
          :style="{ paddingLeft: `${0.5 * item.level - 1}rem` }"
          @click.prevent="goToId(generateChildHeadingId(item.id))"
        >
          {{ item.name }}
        </a>
      </li>
      <li class="tw-py-0.5">
        <a
          v-if="commentsEnabled"
          :href="`#${DISCUSSION_ID}`"
          class="tw-font-medium"
          :class="linkClass"
          @click.prevent="goToId('discussion')"
        >
          {{ $t('discussion') }}
        </a>
      </li>
    </ul>
  </view-section>
</template>

<script>
import LoadingContent from '@components/Loading/LoadingContent.vue'
import ViewSection from '@components/View/ViewSection.vue'
import { scrollToElement } from '@helpers/utils.js'
import { useGuideNav } from '@composables'
import { toRefs } from 'vue'

const linkClass = 'hover:game-link-color focus:game-link-color tw-outline-none'

export default {
  components: {
    LoadingContent,
    ViewSection,
  },
  props: {
    guide: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    commentsEnabled: {
      type: Boolean,
      default: true,
    },
    expandable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { guide } = toRefs(props)

    const { generateChildHeadingId, DISCUSSION_ID, navHeaders, HEADER_ID } =
      useGuideNav(guide)

    return {
      goToId: scrollToElement,
      generateChildHeadingId,
      DISCUSSION_ID,
      navHeaders,
      HEADER_ID,
      linkClass,
    }
  },
}
</script>
